<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import Loader from "@/components/widgets/preloader";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Consumables Stocking Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Loader,
  },
  data() {
    return {
      data: {
        datefrom: "",
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        consumable: "",
        title: "Consumables Stocking Report",
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Consumables Stocking Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Consumables Stocking Report",
          active: true,
        },
      ],
      totalRows: 1,
      total_amount: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      filteredData: [],
      todofilterOn: [],
      sortDesc: false,
      baseFields: [
        {
          key: "index",
          sortable: true,
          label: "S/No",
        },
        {
          key: "item.name",
          sortable: true,
          label: "ITEM",
        },
        {
          key: "unit.name",
          sortable: true,
          label: "UNIT_MEASURE",
        },
        {
          key: "qty",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "unit_price",
          sortable: true,
          label: "UNIT_PRICE",
        },
        {
          key: "total_cost",
          sortable: true,
          label: "TOTAL COST",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "user.name",
          sortable: true,
          label: "RECORDED BY",
        },
      ],
      baseFields1: [
        {
          key: "index",
          sortable: true,
          label: "S/No",
        },
        {
          key: "item.name",
          sortable: true,
          label: "ITEM",
        },
        {
          key: "unit.name",
          sortable: true,
          label: "UNIT_MEASURE",
        },
        {
          key: "qty",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "unit_price",
          sortable: true,
          label: "UNIT_PRICE",
        },
        {
          key: "total_cost",
          sortable: true,
          label: "TOTAL COST",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "user.name",
          sortable: true,
          label: "RECORDED BY",
        },
        {
          key: "branch.name",
          sortable: true,
          label: "BRANCH",
        },
      ],
      json_fields: {
        ITEM: "item.name",
        UNIT_MEASURE: "unit.name",
        QUANTITY: "qty",
        UNIT_PRICE: "unit_price",
        TOTAL_COST: "total_cost",
        BATCH: "batch_number",
        DATE: "date",
        RECORDED_BY: "user.name",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("setting", ["GeneralSettings"]),
    ...mapGetters("consumables", ["ConsumablesStock", "Consumables"]),
    ...mapGetters("auth", ["branchid", "Branches"]),

    fields() {
      let fields = [...this.baseFields]; // copy baseFields
      if (this.GeneralSettings && this.GeneralSettings.track_expiries == 1) {
        fields.splice(6, 0, {
          key: "batch_number",
          sortable: true,
          label: "BATCH",
        });
      }
      return fields;
    },
    fields1() {
      let fields1 = [...this.baseFields1];
      if (this.GeneralSettings && this.GeneralSettings.track_expiries == 1) {
        fields1.splice(7, 0, {
          key: "batch_number",
          sortable: true,
          label: "BATCH",
        });
      }
      return fields1;
    },

    /**
     * Total no. of records
     */

    rows() {
      return this.filteredData ? this.filteredData.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.ConsumablesStock ? this.ConsumablesStock.length : 1;
  },
  methods: {
    ...mapActions({
      FetchConsumableStock: "consumables/fetchConsumablesStock",
      FetchConsumables: "consumables/fetchConsumables",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    SetData() {
      if (this.ConsumablesStock) {
        // Calculate total_cost and add it to each item
        this.filteredData = this.ConsumablesStock.map(item => {
          return {
            ...item,
            total_cost: item.qty * item.unit_price // Calculate and add total_cost
          };
        });
      }
      this.calculateTotalAmount();
    },
    filterReport() {
      let date2 = this.data.dateto;
      let date1 = this.data.datefrom;
      let consumable = this.data.consumable;
      this.filteredData = this.ConsumablesStock.filter((element) => {
        let matchesFilter = true;

        if (
            this.data.consumable != "" &&
            this.data.datefrom == "" &&
            this.data.dateto != ""
        ) {
          this.Consumables.filter((item) => {
            if (item.id == consumable) {
              let expcat = item.name;
              this.data.title =
                  "Consumables Stocking Report For " +
                  expcat +
                  " Up To " +
                  this.data.dateto;
            }
          });
          matchesFilter = element.item.id == consumable && element.date <= date2;
        } else if (
            this.data.consumable == "" &&
            this.data.datefrom != "" &&
            this.data.dateto != ""
        ) {
          this.data.title =
              "Consumables Stocking From " +
              this.data.datefrom +
              " To " +
              this.data.dateto;
          matchesFilter = element.date >= date1 && element.date <= date2;
        } else if (
            this.data.consumable != "" &&
            this.data.datefrom != "" &&
            this.data.dateto != ""
        ) {
          this.Consumables.filter((item) => {
            if (item.id == consumable) {
              let expcatx = item.name;
              this.data.title =
                  "Consumables Stocking for " +
                  expcatx +
                  " From " +
                  this.data.datefrom +
                  " To " +
                  this.data.dateto;
            }
          });
          matchesFilter =
              element.item.id == consumable &&
              element.date >= date1 &&
              element.date <= date2;
        } else {
          matchesFilter = true;
        }
        return matchesFilter;
      }).map(item => { // Calculate total_cost after filtering
        return {
          ...item,
          total_cost: item.qty * item.unit_price
        };
      });

      this.calculateTotalAmount();
    },
    calculateTotalCost(item) {
      return item.qty * item.unit_price;
    },
    calculateTotalAmount() {
      let total_price = 0;
      if (this.filteredData) {
        this.filteredData.forEach((item) => {
          total_price += item.total_cost;
        });
        this.total_amount = total_price;
      }
    },

  },
  updated(){
    this.calculateTotalAmount();

  },

  watch: {
    ConsumablesStock(newValue) {
      if (newValue) {
        this.SetData();
      }
    },
  },
  created() {
    this.SetData();
    this.FetchConsumableStock();
    this.FetchConsumables();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center" v-html="data.title"></h3>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                <download-excel
                class="btn btn-info"
                :data="filteredData"
                :fields="json_fields"
                :worksheet="'CONSUMABLES STOCKING REPORT FOR' + currentdate"
                type="xls"
                :name="'Consumables_stocking_report' + currentdate + '.xls'"
                >
                Export Excel <i class="fa fa-download"></i>
                </download-excel>
              </div>
              <div class="col-md-3 form-group mb-2">
                <label>FROM</label>
                <input
                    @change="filterReport()"
                    type="date"
                    v-model="data.datefrom"
                    class="form-control"
                    v-limit-future-date
                />
              </div>
              <div class="col-md-3 form-group">
                <label>TO</label>
                <input
                    @change="filterReport()"
                    v-model="data.dateto"
                    type="date"
                    class="form-control"
                    v-limit-future-date
                />
              </div>
              <div class="col-md-3 form-group">
                <label>ITEM</label>

                <model-list-select
                    :list="Consumables ? Consumables : []"
                    v-model="data.consumable"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Consumable"
                    @input="filterReport()"
                >
                </model-list-select>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="filteredData ? filteredData : []"
                  :fields="branchid == 0 ? fields1 : fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(unit_price)="data">
                  {{ thousandSeperator(data.item.unit_price) }}
                </template>
                <template #cell(total_cost)="data">
                  {{ thousandSeperator(data.item.total_cost) }}
                </template>
              </b-table>
              <div class="row">
                <div class="col-md-5"></div>
                <div class="col-md-4">
                  <h5>
                    Total Price:
                    <span class="text-danger">{{
                        thousandSeperator(total_amount)
                      }}</span>
                  </h5>
                </div>
              </div>
            </div>
            <Loader v-if="!filteredData" />
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
